module.exports = "/img/_/_/_/assets/images/payment_item//diamonds500.png?cd7b4cdee085128ef60d288ce58e2870";